export default __webpack_public_path__ + "static/media/Sharks.37033407.png";